import { render } from "./UpdateTeam.vue?vue&type=template&id=6dae90f8"
import script from "./UpdateTeam.vue?vue&type=script&lang=js"
export * from "./UpdateTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__